import type { AxiosInstance } from 'axios';

import type { OrderStatus } from '@accio3d/shared/domain';
import type { RfqStatus } from '@accio3d/shared-ui/lib/rfqStatus';

export interface PurchaserDashboardStats {
  activePipeline: number;
  rfqsPending: number;
  ordersInProgress: number;
  totalSavings: number;
  partsNeedingCad: number;
  completedParts: number;
  inProgressParts: number;
}

export interface SupplierDashboardStats {
  activeRfqs: number;
  submittedQuotes: number;
  activeJobs: number;
  activeProjects: number;
  openRequests: number;
  pendingPayout: number;
  winRate: number;
  avgResponseHours: number;
}

interface SupplierActivityItemBase {
  requestId: string;
  partName: string;
  partNumber: string;
  requester: string;
  dueDate: string | null;
}

export type SupplierActivityItem =
  | (SupplierActivityItemBase & { type: 'RFQ'; status: RfqStatus })
  | (SupplierActivityItemBase & { type: 'Order'; status: OrderStatus });

export interface SupplierActivityResponse {
  data: SupplierActivityItem[];
}

export type DashboardService = ReturnType<typeof createDashboardService>;

export function createDashboardService(client: AxiosInstance) {
  return {
    getPurchaserStats(): Promise<PurchaserDashboardStats> {
      return client.get<PurchaserDashboardStats>('/purchasers/dashboard').then((r) => r.data);
    },

    getSupplierStats(supplierId: string): Promise<SupplierDashboardStats> {
      return client
        .get<SupplierDashboardStats>(`/suppliers/${supplierId}/dashboard/statistics`)
        .then((r) => r.data);
    },

    getSupplierActivity(supplierId: string): Promise<SupplierActivityResponse> {
      return client
        .get<SupplierActivityResponse>(`/suppliers/${supplierId}/requests/dashboard`)
        .then((r) => r.data);
    },
  };
}
